// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 320px)";
var _3 = "table-1R9T4";
var _4 = "money-3AFqW";
export { _1 as "__esModule", _2 as "iphone5", _3 as "table", _4 as "money" }
export default { "__esModule": _1, "iphone5": _2, "table": _3, "money": _4 }
